<div class="container-fluid">
  <div class="row">
    <div class="col-md-2">
      <div class="col-lg-12 m-b-10">
        <h3 class="f-s-15 bold">
          <a class="d-block m-b-25 text-primary" routerLink="/admin/sucursales"><i class="fas fa-arrow-left m-r-5"></i>
            Volver a inicio</a>
        </h3>
      </div>
      <div class="nav flex-column nav-pills" id="tab-menu-admin" role="tablist" aria-orientation="vertical">
        <a class="nav-link mb-2" id="tab-company-information" data-bs-toggle="pill"
          routerLink="/admin/empresa/informacion" role="tab">
          <i class="fas fa-info-circle m-r-5"></i> Información empresa</a>
        <a class="nav-link mb-2" id="tab-employees" data-bs-toggle="pill" routerLink="/admin/empresa/empleados/lista"
          role="tab"><i class="fas fa-users m-r-5"></i>Empleados</a>
          <a class="nav-link mb-2" id="tab-employees" data-bs-toggle="pill" routerLink="/admin/empresa/puestostrabajo/lista"
          role="tab"><i class="fas fa-users m-r-5"></i>Puestos trabajo</a>
      </div>
    </div>
    <div class="col-md-10 m-b-100">
      <div class="tab-content mt-4 mt-md-0 bg-white p-b-10">
        <div class="tab-pane active" role="tabpanel">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
